(() => {
  const desktopMenus = () => document.querySelectorAll('[data-dc-desktop]');
  // Delegation also covers Shopify section replacements without duplicate bindings.
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.open) return;
    if (menu.matches('[data-dc-desktop]')) {
      document.querySelectorAll('.header__primary-nav details[open]').forEach(other => {
        if (other !== menu) other.open = false;
      });
    }
    else if (menu.matches('.header__primary-nav details')) {
      desktopMenus().forEach(other => { other.open = false; });
    }
    if (menu.matches('.dc-mobile-section')) {
      document.querySelectorAll('.dc-mobile-section[open]').forEach(other => {
        if (other !== menu) other.open = false;
      });
    }
  }, true);
  document.addEventListener('keydown', event => {
    const menu = event.target.closest('[data-dc-desktop]');
    if (menu && event.key === 'Escape') {
      event.preventDefault(); event.stopPropagation();
      menu.open = false; menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('focusout', event => {
    const menu = event.target.closest('[data-dc-desktop]');
    // WebKit can blur summary to body before a pointer click on a link.
    // Only a known outside focus destination should close the panel here.
    if (menu && event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false;
  });
  document.addEventListener('pointerdown', event => {
    desktopMenus().forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
